const alert = "_alert_1bz08_19";
const content = "_content_1bz08_46";
const title = "_title_1bz08_57";
const icon = "_icon_1bz08_57";
const actions = "_actions_1bz08_73";
const styles = {
  alert,
  content,
  "text-content": "_text-content_1bz08_53",
  title,
  icon,
  actions
};
export {
  actions,
  alert,
  content,
  styles as default,
  icon,
  title
};
//# sourceMappingURL=Alert.module.css.js.map
